import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../components/ui/accordion";
import { useLanguage } from "../i18n/LanguageContext";
import { useApiCollection } from "../hooks/useApiCollection";

export default function FAQ() {
  const { t, lang } = useLanguage();
  const { data: faqs } = useApiCollection("/faqs", []);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#0A0A0A] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-8 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="col-span-12 lg:col-span-4"
          >
            <div className="overline mb-4">{t.faq.overline}</div>
            <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight text-white">
              {t.faq.title}
            </h2>
            <p className="mt-6 text-neutral-400 text-base max-w-sm leading-relaxed">
              {t.faq.subtitle}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="col-span-12 lg:col-span-8"
          >
            <Accordion
              type="single"
              collapsible
              className="border-t border-neutral-800"
              data-testid="faq-accordion"
            >
              {faqs.map((faq) => {
                const q = lang === "ro" ? faq.question_ro : faq.question_en;
                const a = lang === "ro" ? faq.answer_ro : faq.answer_en;
                return (
                  <AccordionItem
                    key={faq.id}
                    value={faq.id}
                    data-testid={`faq-item-${faq.slug}`}
                    className="border-b border-neutral-800"
                  >
                    <AccordionTrigger className="text-left font-display text-base sm:text-lg text-white hover:text-yellow-400 hover:no-underline py-6 [&>svg]:text-yellow-400 [&>svg]:h-5 [&>svg]:w-5">
                      <span className="flex items-start gap-4">
                        <span className="font-mono-tech text-[11px] text-yellow-400 mt-1 shrink-0">
                          {String(faq.order).padStart(2, "0")}
                        </span>
                        <span>{q}</span>
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="text-neutral-400 text-base leading-relaxed pb-6 pl-10">
                      {a}
                    </AccordionContent>
                  </AccordionItem>
                );
              })}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
